
  import { defineComponent } from 'vue';
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';
  import { Button } from '@/ui/components/Button';

  export default defineComponent({
    components: {
      EmptyStateEntry,
      Button,
    },
    setup(_, context) {
      const openModal = () => {
        context.emit('create-report');
      };

      return {
        openModal,
      };
    },
  });
